var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnedice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192,36H64A28.03146,28.03146,0,0,0,36,64V192a28.03146,28.03146,0,0,0,28,28H192a28.03146,28.03146,0,0,0,28-28V64A28.03146,28.03146,0,0,0,192,36Zm20,156a20.02229,20.02229,0,0,1-20,20H64a20.02229,20.02229,0,0,1-20-20V64A20.02229,20.02229,0,0,1,64,44H192a20.02229,20.02229,0,0,1,20,20Zm-96-84a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,116,108Zm40,40a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,156,148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnedice);
export default __webpack_public_path__ + "static/media/onedice.cd284f37501ff983804adba043e33c47.svg";
export { ForwardRef as ReactComponent };